import type { PrincipalRole } from "@backchannel/tax-contracts";
import { parsePrincipalRole } from "./roles";

export const ROLE_PREVIEW_STORAGE_KEY = "backchannel.tax.preview-role";

export const PREVIEWABLE_ROLES: readonly PrincipalRole[] = [
  "TAX_COMMERCIAL",
  "TAX_MANAGER",
  "TAX_DEVELOPER",
  "TAX_READER",
];

export function readStoredPreviewRole(): PrincipalRole | null {
  try {
    return parsePrincipalRole(window.sessionStorage.getItem(ROLE_PREVIEW_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function writeStoredPreviewRole(role: PrincipalRole | null) {
  try {
    if (!role || role === "SUPER_ADMIN") {
      window.sessionStorage.removeItem(ROLE_PREVIEW_STORAGE_KEY);
      return;
    }
    window.sessionStorage.setItem(ROLE_PREVIEW_STORAGE_KEY, role);
  } catch {
    // Session storage can be unavailable in a locked-down browser profile.
  }
}
